import { Tab, TabProps, Typography } from '@mui/material';

import { useIsSMDown } from 'uiKit/Theme/useTheme';

import { useBillingTabStyles } from './useBillingTabStyles';

export interface BillingTabProps extends TabProps {
  label: string;
  value: number;
}

export const BillingTab = ({ label, value, ...props }: BillingTabProps) => {
  const { classes } = useBillingTabStyles();
  const isMobile = useIsSMDown();

  const variant = isMobile ? 'subtitle2' : 'subtitle1';

  return (
    <Tab
      classes={classes}
      label={<Typography variant={variant}>{label}</Typography>}
      value={value}
      {...props}
    />
  );
};
